import { PromiseResponseProps } from "@/config/types/common";
import request from "@/utils/request";

/**
 * 邮件配置
 * @see http://apidoc.stac.fun/project/682/interface/api/65861
 */

export function getEmailConfig(): PromiseResponseProps<{
  emailHint: string; // 提示语
}> {
  return request({
    url: "/estate/v1/email/config",
    method: "get",
  });
}

/**
 * 在线留言
 * @see http://apidoc.stac.fun/project/682/interface/api/65841
 */
export const sendAdvice = (data: { adviceType: string; adviceDesc: string }) => {
  return request({
    url: "/estate/v1/email/write",
    method: "post",
    data,
  });
};

/**
 * 我的留言
 * @see http://apidoc.stac.fun/project/682/interface/api/65836
 */
export const getMyAdvice = (data: { pageNum: number; pageSize: number }) => {
  return request({
    url: "/estate/v1/email/get_my",
    method: "post",
    data,
  });
};
